import mixpanel from 'mixpanel-browser';
import isUUID from 'validator/es/lib/isUUID';
import { mixpanelId } from '../config';
import { ProgramType } from '../types/types';
import { MIXPANEL_EVENTS, PROJECT_PREFIX } from './mixpanel-consts';

const PAGE_PATH: string = 'page_path';

mixpanel.init(mixpanelId, {
  debug: process.env.REACT_APP_ENV !== 'production',
  ignore_dnt: true,
  batch_requests: false,
  loaded: resetUser,
});

export function registerAccessCodeSuperProperty(accessCode: string): void {
  mixpanel.register({
    accessCode,
    programType: ProgramType.flex,
  });
}

export function registerAssessmentIdSuperProperty(assessmentId: string): void {
  mixpanel.register({
    assessmentId,
  });
}

export function track(eventName: string, data: any = {}): void {
  const eventData = normalizeEventAttributeValues(data);
  mixpanel.track(`${PROJECT_PREFIX}:${eventName}`, eventData);
}

export function trackPageViewInMixpanel(
  page: string,
  additionalData?: any
): void {
  const data: { [key: string]: string } = {
    [PAGE_PATH]: page.toLowerCase(),
    ...(additionalData && additionalData),
  };

  track(MIXPANEL_EVENTS.PAGE_VIEW, data);
}

export function registerUserInMixpanel(userSub: string, data: any): void {
  registerUnloadEventForMixpanel();
  const personData = makePersonData(data);
  mixpanel.people.set(personData, () => identifyUser(userSub));
  track(MIXPANEL_EVENTS.REGISTRATION_COMPLETE, personData);
}

export function identifyUser(userId: string): void {
  if (userId && isUUID(userId, 4)) {
    mixpanel.identify(userId);
  }
}

export function resetUser(): void {
  mixpanel.reset();
}

export function registerUnloadEventForMixpanel(): void {
  window.addEventListener('beforeunload', resetUser);
}

export function getMixpanelDistinctId(): any {
  return mixpanel.get_distinct_id();
}

function makePersonData(data: Record<string, any>): Record<string, any> {
  let personData: Record<string, any> = {};

  for (let key in data.userData) {
    if (data.userData[key].length > 0) {
      personData[`$custom:${key}`] = data.userData[key][0];
    }
  }

  return personData;
}

function normalizeEventAttributeValues(
  eventData: Record<string, any>
): Record<string, any> {
  const data = { ...eventData };
  if (data[PAGE_PATH]) {
    data[PAGE_PATH] = data[PAGE_PATH].toLowerCase();
  }
  return data;
}
